import { render } from "./Relationship.vue?vue&type=template&id=7839b4f0&scoped=true"
import script from "./Relationship.vue?vue&type=script&lang=js"
export * from "./Relationship.vue?vue&type=script&lang=js"

import "./Relationship.vue?vue&type=style&index=0&id=7839b4f0&lang=scss&scoped=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7839b4f0"]])

export default __exports__